import { useMutation, useQueryClient } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import { useSchoolSchoolyear } from '@teetsh/app/src/containers/App/context/SchoolyearSchoolProvider';
import { ELEVES_VIEWS_KEY } from '@teetsh/app/src/queries/eleves/views/useElevesViews';

function deleteEleveViewFilter(props: {
  schoolyearId: string;
  schoolId: string;
  viewId: string;
  filterId: string;
}) {
  const requestURL = `/schoolyears/${props.schoolyearId}/schools/${props.schoolId}/eleves-views/${props.viewId}/filters/${props.filterId}`;
  return request(requestURL, {
    method: 'DELETE',
  });
}

export default function useDeleteElevesViewFilter(viewId: string) {
  const { schoolyear, school } = useSchoolSchoolyear();
  const queryClient = useQueryClient();

  const { mutateAsync } = useMutation({
    mutationFn: (filterId: string) =>
      deleteEleveViewFilter({
        schoolyearId: schoolyear.id,
        schoolId: school.id,
        viewId,
        filterId,
      }),

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [ELEVES_VIEWS_KEY],
      });
    },
  });
  return mutateAsync;
}
